import { useEffect, useState } from "react";
import PublicLayout from "@/components/PublicLayout";
import EditablePage from "@/components/pagebuilder/EditablePage";
import RichContent from "@/components/RichContent";
import api from "@/lib/api";
import { useT } from "@/context/LanguageContext";
import { localizedContent } from "@/lib/localize";

export default function Programs() {
  const { t, lang } = useT();
  const [page, setPage] = useState(null);
  useEffect(() => { api.get("/cms/pages/programs").then((r) => setPage(r.data)).catch(() => {}); }, []);
  const c = localizedContent(page?.content, lang);
  const programs = c.programs || [];

  return (
    <PublicLayout>
      <EditablePage slug="programs" page={page} onSaved={setPage}>
      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-20 md:py-28" data-testid="programs-page">
        <div className="text-[10px] uppercase tracking-[0.32em] text-[var(--dojo-ink-soft)] mb-4">{c.eyebrow || t("page.programs_eyebrow")}</div>
        <h1 className="font-serif text-5xl md:text-7xl tracking-tight leading-[0.95] mb-16 max-w-3xl">
          {c.heading || t("page.programs_heading")}
        </h1>
        <div className="grid md:grid-cols-2 gap-0 border border-[var(--dojo-border)]">
          {programs.map((p, i) => (
            <div
              key={i}
              className={`p-10 ${i % 2 === 0 ? "md:border-r border-[var(--dojo-border)]" : ""} ${i >= 2 ? "border-t border-[var(--dojo-border)]" : ""} ${i > 0 && i % 2 === 1 ? "border-t md:border-t-0" : ""}`}
            >
              <div className="text-[10px] uppercase tracking-[0.3em] text-[var(--dojo-green)] mb-3">{t("page.program_label")} · 0{i + 1}</div>
              <h3 className="font-serif text-3xl md:text-4xl mb-4 tracking-tight">{p.name}</h3>
              {/^\s*</.test(p.desc || "") ? (
                <RichContent html={p.desc} className="text-[var(--dojo-ink-soft)] [&_p]:leading-relaxed" />
              ) : (
                <p className="text-[var(--dojo-ink-soft)] leading-relaxed">{p.desc}</p>
              )}
            </div>
          ))}
        </div>
      </section>
      </EditablePage>
    </PublicLayout>
  );
}
